import { render } from "./poioklotGeneral.vue?vue&type=template&id=1df2b791"
import script from "./poioklotGeneral.vue?vue&type=script&lang=js"
export * from "./poioklotGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__